import * as React from 'react'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import { Violation } from '@/app/types/creator'
import useFormatDate from '@/modules/drivers/hooks/useFormatDate'
import { getViolationName } from '@/app/services/violation/violationNameResolver'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { formatTimespan } from '@/app/common/dateHelper'
import { FaIcon } from '@/lib/fa'
import {
  getViolationWeightIcon,
  ViolationWeightType,
} from '@/modules/drivers/tabs/violations_new/hooks/useViolationsIcon'

export const ViolationDetailsRow = ({
  violation,
}: {
  violation: Violation | any
}) => {
  const { formatDateWithTime } = useFormatDate()

  const [isHovered, setIsHovered] = React.useState(false)

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  const { t } = useLocalize()

  return (
    <>
      <tr
        className={`notches-border--right tw-relative tw-w-fit tw-cursor-pointer tw-border-b hover:tw-bg-primary/10 tw-bg-white`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <TableTextRow
          size="medium"
          icon={
            <FaIcon
              icon={getViolationWeightIcon(violation?.weight)}
              className={`${violation?.weight.includes(ViolationWeightType.NN) && 'tw-text-red-500'} `}
            />
          }
        >
          {violation?.weight}
        </TableTextRow>
        <TableTextRow size="medium" textSize="xs">
          {t(getViolationName(violation?.type))}
        </TableTextRow>
        <TableTextRow size="medium" textSize="xs">
          {formatDateWithTime(violation?.startTime)}
        </TableTextRow>
        <TableTextRow size="medium" textSize="xs">
          {formatDateWithTime(violation?.endTime)}
        </TableTextRow>
        <TableTextRow size="medium" textSize="xs">
          {formatTimespan(violation?.exceededBy)}
        </TableTextRow>
        <TableTextRow size="medium" textSize="xs">
          {violation?.chargeSymbol}
        </TableTextRow>
        <TableTextRow size="medium" textSize="xs">
          {violation?.driverCharge}
        </TableTextRow>
        <TableTextRow size="medium" textSize="xs">
          {violation?.companyCharge}
        </TableTextRow>
      </tr>
    </>
  )
}
